import { auth } from '../auth/auth';
import { geo } from '../geo/geo';

const LEGACY_API_BASE = 'https://zjx6kmaei3.execute-api.us-east-1.amazonaws.com/default';
const NEW_API_BASE = 'https://api.charmed.biz';

export const api = {

  async apiQuery(method, handler, params) {
    return this._apiQueryWithBase(NEW_API_BASE, method, handler, params);
  },

  async apiQueryNew(method, handler, params) {
    return this._apiQueryWithBase(NEW_API_BASE, method, handler, params);
  },

  _buildUrl(baseUrl, handler, method, params) {
    let url = `${baseUrl}${handler}`;

    if (method === 'GET' && params && Object.keys(params).length > 0) {
      const searchParams = new URLSearchParams();
      Object.keys(params).forEach((key) => {
        const value = params[key];
        if (typeof value === 'object' && value !== null) {
          searchParams.append(key, JSON.stringify(value));
        } else {
          searchParams.append(key, value);
        }
      });
      url += `?${searchParams.toString()}`;
    }

    return url;
  },

  _addLocation(params) {
    if (!params) {
      return params;
    }

    const requestParams = { ...params };
    const location = geo.getCurrentPosition();
    if (location.latitude && location.longitude) {
      requestParams.location = location;
    }

    return requestParams;
  },

  async _apiQueryWithBase(baseUrl, method, handler, params) {
    console.log('Making API query');
    const token = await auth.getToken();
    if (!token) {
      console.log('No token found');
    }

    try {
      const requestParams = this._addLocation(params);
      const url = this._buildUrl(baseUrl, handler, method, requestParams);
      const options = {
        method,
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      };

      if (method === 'POST' && requestParams) {
        options.body = JSON.stringify(requestParams);
      }

      let response = await fetch(url, options);
      let data = await response.json();

      if (data?.message === 'Unauthorized') {
        console.log('Received Unauthorized, attempting token refresh');

        const newToken = await auth.refreshAccessToken();

        if (!newToken) {
          throw new Error('Session expired. Please log in again.');
        }

        console.log('Token refreshed, retrying original request');
        options.headers.Authorization = `Bearer ${newToken}`;

        response = await fetch(url, options);
        data = await response.json();

        if (!response.ok) {
          return data;
        }
      }

      if (!response.ok) {
        return data;
      }

      return data;
    } catch (error) {
      console.error('Error making API query:', error);
      return null;
    }
  }
}
